<ng-dialog-header [title]=title></ng-dialog-header>
<mat-dialog-content class="overflow-auto d-flex flex-column" style="height: 57vh;">
  <ns-grid
    name="MONITOR_DATE"
    [columns]="columns"
    [config]="config"
    [gridOptions]="gridOptions"
    [gridTitle]="gridTitle"
    [data]="monitoredLeaseTrack.leaseTracks"
  >
    <div class="row d-flex flex-grow-1 justify-content-center" grid-header>
      <div class="col-auto font-weight-bold">Summary:</div>
      <div class="col-auto">Lease Track Capacity: {{ monitoredLeaseTrack.capacity }}</div>
      <div class="col-auto">|</div>
      <div class="col-auto">Total Excess Cars: {{ monitoredLeaseTrack.excess }}</div>
    </div>
    <div class="d-flex w-100 justify-content-end align-items-center" grid-footer>
      <mat-icon class="align-baseline bg-travertine icon-color mr-1" fontSet="fas" fontIcon="fa-square"></mat-icon>
      <div>Excess Lease Track</div>
    </div>
  </ns-grid>
</mat-dialog-content>
